import React, { useEffect, useState } from "react";
import Base from '../../utils/base'

export default function Promotion(props) {
  var base = new Base()
  const [arrPromotion, setArrPromotion] = useState([])
  const [arrBestPromotion, setArrBestPromotion] = useState([])
  const [homePromotion, setHomePromotion] = useState({})
  const [bestHomePromotion, setBestHomePromotion] = useState({})

  useEffect(() => {
    get_info_data()
    get_info_data2()
    get_promotion_data()
    get_best_promotion_data()
  }, [])

  async function get_promotion_data() {
		var response = await base.request(base.url_api + "/promotion/all")

		if(response != null){
			if(response.status == "success"){
				setArrPromotion(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  async function get_best_promotion_data() {
		var response = await base.request(base.url_api + "/promotion/best/all")

		if(response != null){
			if(response.status == "success"){
				setArrBestPromotion(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  async function get_info_data() {
		var response = await base.request(base.url_api + "/info?type=home_promotion&lang=id")

		if(response != null){
			if(response.status == "success"){
				setHomePromotion(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  async function get_info_data2() {
		var response = await base.request(base.url_api + "/info?type=best_home_promotion&lang=id")

		if(response != null){
			if(response.status == "success"){
				setBestHomePromotion(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  return (
    <section class="promotion-one">
      <div class="container mt-3">
        <div class="sec-title text-center">

          {/* <img src="assets/images/shapes/sec-title-s-1.png" alt="Promotion" class="sec-title__img" /> */}


          <h6 class="sec-title__tagline bw-split-in-right" style={{ fontSize: '.8rem', }}>{homePromotion.title}</h6>

          <h3 class="sec-title__title bw-split-in-up text-uppercase" style={{ fontSize: '3.125rem', }}>{homePromotion.subtitle}</h3>
        </div>
        <div class="row gutter-y-30">
          <div class="col-xl-4 col-lg-5">
            <div class="promotion-one__sidebar wow fadeInLeft" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div class="promotion-one__sidebar__bg" style={{ backgroundImage: "url(" + homePromotion.url_image2 + ")", }}></div>
              <div class="promotion-one__sidebar__top">
                <div class="promotion-one__sidebar__funfact count-box">
                  <h3 class="promotion-one__sidebar__count" style={{ fontSize: '2.5rem', }}>
                    {/* <span class="promotion-one__sidebar__count__item count-text" data-stop={bestHomePromotion.title} data-speed="1500"></span> */}
                    <span>{bestHomePromotion.title}</span>
                  </h3>
                  {/* <p class="promotion-one__sidebar__text">Off</p> */}
                </div>
                <div class="promotion-one__sidebar__room-quality" style={{ fontSize: '1.4rem', }}>
                  {bestHomePromotion.subtitle}
                  {/* <img src="assets/images/shapes/promotion-card-shape-1-2.png" alt /> */}
                </div>
              </div>
              <div class="promotion-one__sidebar__bottom">
                {
                  arrBestPromotion.map((temp, index) => (
                    <a href={temp.title == 'online reservation' ? '#' : '#!'}>
                      <div class="promotion-one__sidebar__item" >
                        <img className="promotion-one__sidebar__item__icon" src={temp.url_image} alt={"Best Promotion " + index}/>
                        {/* <div class="promotion-one__sidebar__item__icon">
                          <i class="icon-tour-guide-1"></i>
                        </div> */}
                        <div class="promotion-one__sidebar__item__content">
                          <h5 class="promotion-one__sidebar__item__title" style={{ fontSize: '1.2rem', }}>{base.capitalizeFirstLetter(temp.title)}</h5>
                          <p class="promotion-one__sidebar__item__text" style={{ fontSize: '.8rem', }}>{base.capitalizeFirstLetter(temp.subtitle)}</p>
                        </div>
                      </div>
                    </a>
                  ))
                }
                
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-lg-7">
            <div class="promotion-one__content">
              <div class="promotion-one__content__bg wow fadeInLeft" data-wow-duration='1500ms' data-wow-delay='600ms' style={{ backgroundImage: "url(" + homePromotion.url_image1 + ")", }}></div>

              {
                arrPromotion.map((promotion, index) => (
                  <div class="promotion-one__content__item wow fadeInUp d-flex align-items-stretch" data-wow-duration='1500ms' data-wow-delay='300ms' key={index}>
                    <div class="promotion-one__content__item__content">
                      <p class="promotion-one__content__item__top" style={{ fontSize: '1rem', }}>{promotion.duration}</p>
                      <h5 class="promotion-one__content__item__title" style={{ fontSize: '1.4rem', }}>{base.capitalizeFirstLetter(promotion.title)}</h5>
                      <p class="promotion-one__content__item__text" style={{ fontSize: '1rem', }}>{base.capitalizeFirstLetter(promotion.subtitle)}</p>
                      {/* <a href="/rooms" class="solinom-btn solinom-btn--base">View Details</a> */}
                    </div>
                    <div class="promotion-one__content__item__thumb">
                      <div class="promotion-one__content__item__thumb__item h-100">
                        <img src={promotion.url_image} alt="solinom image" height={"100%"}/>
                      </div>
                      {/* <span class="promotion-one__content__item__thumb__price">Rp. {promotion.price.toLocaleString(base.locale_string)}</span> */}
                    </div>
                  </div>
                ))
              }
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
